

<h1 mat-dialog-title>{{data.header}}</h1>
<div mat-dialog-content scrollListener (scroll)="scrollSubject.next(null)">
  <ng-container *ngTemplateOutlet="data.content;context:contentData"></ng-container>
</div>

